var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69727 27.6715V1H35.9988",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3027 27.672V11.3047",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3027 11.3042H35.9985V1L46.3027 11.3042Z",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2944 7.59766H22.8035",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2944 14.1953H22.8035",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1621 47.3409H41.0635C45.103 47.3409 45.9727 43.4605 45.9727 43.4605H53.9997V27.8348H39.8764C38.3769 27.8348 36.9389 27.2392 35.8785 26.1789C34.6844 24.9847 33.0977 24.4217 31.5341 24.4899C30.1398 24.5515 28.7631 25.1145 27.6976 26.1789L17.8135 36.063C20.4261 38.6756 24.6617 38.6756 27.2743 36.063L30.8039 32.5333",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7778 32.5615L37.9075 39.6912C38.9906 40.7743 38.9906 42.5314 37.9075 43.6145C36.8233 44.6987 35.0662 44.6987 33.9831 43.6145",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0586 47.5384C31.1428 48.6215 32.8988 48.6215 33.983 47.5384C35.0661 46.4542 35.0661 44.6982 33.983 43.614L30.8446 40.4756",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9077 44.3877L30.0586 47.5387C31.1428 48.6217 31.1428 50.3789 30.0586 51.4631C28.9755 52.5462 27.2184 52.5462 26.1353 51.4631L23.9361 49.2639L22.9707 48.2985",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3164 27.835H1V43.46H10.2849L20.0118 53.1869C21.0819 54.2582 22.8099 54.271 23.8968 53.2255C25.0184 52.1469 24.9925 50.3199 23.8921 49.2195L22.9708 48.2982",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFrame);
export default __webpack_public_path__ + "static/media/icon-frame.fb8c69bb63e2d7f9c53a01dfd8282b2e.svg";
export { ForwardRef as ReactComponent };